import React from "react";
import "./bodysection5.css";

const BodySection5 = () => {
  return (
    <div className="video-container">
      <div className="video-grid">
        <iframe
          src="https://www.youtube.com/embed/uKYYWYaFNY0"
          title="College Video 1"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />

        <iframe
          src="https://www.youtube.com/embed/-eHpYs39p10"
          title="College Video 2"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />

        <iframe
          src="https://www.youtube.com/embed/zTmeRymbdAY"
          title="College Video 3"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />

        <iframe
          src="https://www.youtube.com/embed/O7yoytPiMEg"
          title="College Video 4"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />

       
        <div className="video-wrapper">
          <video
          poster="/vedio/thubnail.png"
          controls
          preload="metadata"
          style={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
          display: "block"
        }}
>
  <source src="/vedio/vedio.mp4" type="video/mp4" />
</video>
        </div>
      </div>
    </div>
  );
};

export default BodySection5;